export default __webpack_public_path__ + "static/media/hammer-nodata.b9f9fba9.svg";